import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance_create = get_axios_instance(api_variables.SERVICE_CREATE_PUSH_FBP);

const _pk_name = "id";

const state = {
    data: [],
    employeeData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};
const getters = {

}
const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEmployeeData: (state, payload) => {
        if (payload) {
            state.employeeData = payload;
        }
        //console.log('fetched exits', state.employeeData)
    },
    updateEmployeeFBPClaimsById: (state, payload) => {
        //console.log(payload);
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async create({ commit }, payload) {
        //console.log("pushFbpConfiguration.... Adding...", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_create.post('', payload);
            commit("setSaving", false);
            //console.log("pushFbpConfiguration......... res: ", res);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch {

        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}